import { CiLocationOn } from "react-icons/ci";
import { TfiBag } from "react-icons/tfi";
import { MdOutlineAccountBalanceWallet } from "react-icons/md";
import moment from "moment";
import { IoMdArrowRoundBack } from "react-icons/io";
import { useEffect, useState } from "react";

export const Image = ({ src, className = "img-fluid" }) => {
  return <img src={src} className={className} alt="logo" />;
};

export const SelectwithIcons = ({
  className = "form-control px-5",
  options,
  placeholder,
  name,
  value,
  icons,
  onChange,
  disabled = false,
}) => {
  return (
    <div className="mt-2 positions-input-field">
      <select
        className={className}
        placeholder={placeholder}
        name={name}
        value={value}
        onChange={onChange}
        disabled={disabled}
      >
        {options?.map((ele, index) => (
          <option value={ele?.value} key={index}>
            {ele?.label}
          </option>
        ))}
      </select>

      <i className="input-field-icons">{icons}</i>
    </div>
  );
};

export const InputwithIcons = ({
  className = "form-control px-5",
  placeholder,
  name,
  value,
  type,
  icons,
  onChange,
  disabled = false,
  maxDate,
  minDate,
  onInput,
  onBlur,
  onKeyDown,
  autoComplete,
}) => {
  return (
    <div className="mt-2 positions-input-field">
      <input
        className={className}
        autoComplete={autoComplete}
        onKeyDown={onKeyDown}
        onBlur={onBlur}
        onInput={onInput}
        placeholder={placeholder}
        name={name}
        value={value}
        type={type}
        onChange={onChange}
        max={maxDate}
        min={minDate}
        disabled={disabled}
      />
      <i className="input-field-icons">{icons}</i>
    </div>
  );
};

export const DatewithIcons = ({
  className = "form-control px-5",
  placeholder,
  name,
  value,
  type,
  icons,
  onChange,
  disabled = false,
  maxDate,
  minDate,
  onInput,
  onBlur,
  onKeyDown,
  autoComplete,
}) => {
  return (
    <div className="mt-2 positions-input-field">
      <input
        className={className}
        autoComplete={autoComplete}
        onKeyDown={onKeyDown}
        onBlur={onBlur}
        onInput={onInput}
        placeholder={placeholder}
        name={name}
        value={value}
        type={"date"}
        onChange={onChange}
        max={maxDate}
        min={minDate}
        disabled={disabled}
      />
      <i className="input-field-icons">{icons}</i>
    </div>
  );
};

export const InputWithCheckbox = ({
  className,
  name,
  checked,
  type = "checkbox",
  label,
  onChange,
}) => {
  return (
    <div className="mt-1 positions-input-field d-flex">
      <input
        className={className}
        name={name}
        checked={checked}
        type={type}
        onChange={onChange}
      />
      <label style={{ fontSize: "12px", marginLeft: "5px" }}>{label}</label>
    </div>
  );
};

export const Buttons = ({ className, name, type, onClick, isDisable }) => {
  return (
    <button
      className={className}
      type={type}
      onClick={onClick}
      disabled={isDisable}
    >
      {name}
    </button>
  );
};

export const CommonCard = ({ data, key }) => {
  const handleTestDetails = (data) => {
    const sampleType = data?.TestDetail?.map((ele, index) => (
      <span key={index}>{ele?.SampleTypeName}</span>
    ));

    const totalSum = data?.TestDetail?.reduce(
      (a, item) => parseInt(item.NetAmt) + a,
      0
    );

    return {
      sampleType,
      totalSum,
    };
  };

  return (
    <>
      <div className="mb-3 box-shadow line-height" key={key}>
        <div className="d-flex justify-content-between">
          <div>
            <p className="patientStyle m-0">{data?.PatientName}</p>
            <div className="d-flex align-items-baseline">
              <div>
                <CiLocationOn />
              </div>
              <div style={{ color: "grey", fontSize: "12px" }} className="mx-2">
                {data?.House_No},{data?.PinCode}
              </div>
            </div>

            <div className="d-flex align-items-baseline">
              <div>
                <TfiBag />
              </div>
              <div style={{ color: "grey", fontSize: "12px" }} className="mx-2">
                {data?.City},{data?.State}
              </div>
            </div>

            <div className="d-flex align-items-baseline">
              <div>
                <MdOutlineAccountBalanceWallet />
              </div>
              <div style={{ color: "grey", fontSize: "12px" }} className="mx-2">
                {data?.PaymentMode}
              </div>
            </div>
          </div>
          <div className="text-end">
            <div>
              <small>{moment(data?.AppDate).format("LT")}</small>
            </div>
            <div>
              <small className="text-success">{data?.CStatus}</small>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export const dateFormat = (date) => {
  const mainDate = moment(date?.AppDate).format("DD MMM,YYYY");
  return `${mainDate} (${moment(mainDate).calendar().split(" ")[0]})`;
};

export const filterByTypeAndDate = (filterData) => {
  let dates = [];

  for (let i = 0; i < filterData.length; i++) {
    if (
      !dates.includes(moment(filterData[i]["AppDate"]).format("DD-MMM-YYYY"))
    ) {
      dates.push(moment(filterData[i]["AppDate"]).format("DD-MMM-YYYY"));
    }
  }

  return { filterData, dates };
};

export const NoDataFound = () => {
  return (
    <div className="d-flex flex-direction-column align-items-center justify-content-center text-danger">
      No Data Found
    </div>
  );
};

export const GOBack = ({ action }) => {
  return (
    <div
      className="container-fluid pt-2 text-primary"
      style={{ fontSize: "16px" }}
    >
      <span onClick={action}>
        <IoMdArrowRoundBack />
        Back
      </span>
    </div>
  );
};

const S4 = () => {
  return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
};

export const guidNumber = () => {
  const guidNumber =
    S4() +
    S4() +
    "-" +
    S4() +
    "-" +
    S4() +
    "-" +
    S4() +
    "-" +
    S4() +
    "-" +
    S4() +
    S4();

  return guidNumber;
};
